import { render, staticRenderFns } from "./TotDay.vue?vue&type=template&id=06cbf2f5&scoped=true&"
import script from "./TotDay.vue?vue&type=script&lang=js&"
export * from "./TotDay.vue?vue&type=script&lang=js&"
import style0 from "./TotDay.vue?vue&type=style&index=0&id=06cbf2f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cbf2f5",
  null
  
)

export default component.exports